// extracted by mini-css-extract-plugin
export default {"overlay":"Pages_overlay__rYGSN"};